import PageLayout, {PageDescription} from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

const NotFoundPage = () => {
  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.NOTFOUND_ERROR}}
      footerProps={{type: 'simple'}}
      showLogo
      pageDescription={PageDescription.ACCOUNT}
    >
      <div className="wrap_comm wrap_error">
        <div className="cont_comm">
          <strong className="tit_info">페이지를 찾을 수 없습니다</strong>
          <p className="desc_info">주소를 다시 확인해 주세요.</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFoundPage;
